export var LegacyCardDataHooks = {
    mediaContainer: 'legacyCardMediaContainer',
    infoContainer: 'legacyCardInfoContainer',
};
//# sourceMappingURL=constant.js.map